// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ChecklistTemplateController from "./checklist_template_controller"
application.register("checklist-template", ChecklistTemplateController)

import NipLookupController from "./nip_lookup_controller"
application.register("nip-lookup", NipLookupController)

import DragUploadController from "./drag_upload_controller"
application.register("drag-upload", DragUploadController)

import BuyerKindController from "./buyer_kind_controller"
application.register("buyer-kind", BuyerKindController)

import AccountingProviderController from "./accounting_provider_controller"
application.register("accounting-provider", AccountingProviderController)

import KalkulatorController from "./kalkulator_controller"
application.register("kalkulator", KalkulatorController)
